// used for numerical status values (0,1,2,3...)
export const STATUS_COLOR_REGISTRY: Partial<
  Record<StatusDomain, readonly string[]>
> = {
  absenceRequest: ['', 'gray', 'green', 'red', 'red'],
  project: ['gray', 'blue', 'green', 'blue', 'green', '', '', '', '', 'gray'],
  case: ['gray', 'blue', 'green', 'green'],
  standingOrder: ['gray', 'blue', 'green', 'green'],
  materialReservation: ['orange', 'green', 'black'],
  workOrder: ['gray', 'blue', 'green', 'green'],
  equipmentOperatingState: ['green', 'orange', 'red'],
  // Checklist check result types: 1 Text, 2 Toggle, 3 Number, 4 Date.
  // Not a status, so green/red (done/error) are deliberately not used.
  checkResultType: ['', 'gray', 'blue', 'orange', 'black'],
};

// used for string or boolean status values (e.g. 'CREATED', 'SENT', 'COMPLETED')
export const STATUS_COLOR_KEYED_REGISTRY: Partial<
  Record<StatusDomain, Record<string, string>>
> = {
  basic: {
    ACTIVE: 'green',
    INACTIVE: 'gray',
  },
  materialReservation: {
    CREATED: 'orange',
    SENT: 'green',
    COMPLETED: 'black',
  },
  shiftBook: {
    DRAFT: 'gray',
    SUBMITTED: 'green',
  },
  standstill: {
    true: 'blue',
    false: 'red',
  },
  maintenanceNotification: {
    CREATED: 'gray',
    SENT_TO_SAP: 'gray',
    WORK_CREATED: 'gray',
    EXTERNAL_CHECK: 'gray',
    IN_WORK: 'blue',
    PAUSED: 'blue',
    DONE: 'green',
    COMPLETED: 'green',
    REJECTED: 'red',
  },
  workStepResolutionState: {
    RESOLVED: 'green',
    UNRESOLVED: 'red',
  },
  // Checklist check "mandatory" flag.
  checkMandatory: {
    true: 'blue',
    false: 'gray',
  }
};

export type StatusDomain =
  | 'absenceRequest'
  | 'basic'
  | 'case'
  | 'checkMandatory'
  | 'checkResultType'
  | 'equipmentOperatingState'
  | 'maintenanceNotification'
  | 'project'
  | 'materialReservation'
  | 'shiftBook'
  | 'standingOrder'
  | 'standstill'
  | 'workOrder'
  | 'workStepResolutionState'
  ;
